import { render, staticRenderFns } from "./v-check-data-popup.vue?vue&type=template&id=4db4d7bc&scoped=true"
import script from "./v-check-data-popup.vue?vue&type=script&lang=js"
export * from "./v-check-data-popup.vue?vue&type=script&lang=js"
import style0 from "./v-check-data-popup.vue?vue&type=style&index=0&id=4db4d7bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db4d7bc",
  null
  
)

export default component.exports